export default __webpack_public_path__ + "static/media/veirfyInProgress-desktop.9bec2d17.png";